<script>
  import TodoItem from "./TodoItem.svelte";

  import { user } from "./refs/store.js";
  import { db } from "./refs/firebase";
  import { collectionData } from "rxfire/firestore";
  import { startWith } from "rxjs/operators";
  import { empty, of } from "rxjs";

  let text = "some task";
  export let uid;

  const query = db
    .collection("todos")
    .where("uid", "==", uid)
    .orderBy("created");
  let todos = collectionData(query, "id").pipe(startWith([]));

  function add() {
    db.collection("todos").add({
      uid,
      text,
      complete: false,
      created: Date.now()
    });
    text = "";
  }
  function updateStatus(event) {
    console.log(event);
    const { id, newStatus } = event.detail;
    db.collection("todos")
      .doc(id)
      .update({ complete: newStatus });
  }
  function removeItem(event) {
    const { id } = event.detail;
    db.collection("todos")
      .doc(id)
      .delete();
  }
</script>

<style>
  input {
    display: block;
  }
  .entry {
    margin-top: 20px;
  }
</style>

<ul>
    {#each $todos as todo}
      <TodoItem {...todo} on:remove={removeItem} on:toggle={updateStatus} />
    {/each}
</ul>

<div class="entry">
  <div class="field is-horizontal">
    <div class="label is-normal">
      <label class="label" />
    </div>
    <div class="field-body">
      <div class="field">
        <p class="control">
          <input
            class="input"
            type="text"
            placeholder="New tesk"
            bind:value={text} />
        </p>
      </div>
    </div>
  </div>

  <div class="field is-grouped">
    <div class="control">
      <label class="field-label">Your task:</label>
    </div>
    <div class="control">
      <label class="field-label">{text}</label>
    </div>
  </div>

  <div class="field is-horizontal margin-right">
    <div class="label is-normal">
      <label class="label" />
    </div>
    <div class="field-body">
      <div class="field">
        <p class="control">
          <button class="button is-info" on:click={add}>Add Task</button>
        </p>
      </div>
    </div>
  </div>
</div>
